import styled from 'styled-components'

export const Edit = styled.span`
  margin-right: ${({ theme }) => theme.space[1]}px;
`

export const Title = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.body};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`

export const SubTitle = styled.h2`
  margin-top: 24px;
  margin-bottom: 8px;
  font-size: ${({ theme }) => theme.fontSizes.body};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
`

export const Description = styled.p`
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: ${({ theme }) => theme.fontSizes.small};
`

export const Container = styled.div<{ isLoading: boolean }>`
  position: relative;
  width: 100%;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 20px; /* stylelint-disable-line scales/radii */
  border: 1px solid ${({ theme }) => theme.colors.border[2]};
  background-color: ${({ theme }) => theme.colors.background.secondary[2]};
  box-shadow: ${({ theme }) =>
    `${theme.colors.shadow.inner} 0 1px 2px 0 inset;`};

  ${({ isLoading }) =>
    isLoading &&
    `
      pointer-events: none;
      opacity: 0.5;
    `}
`

export const Dropzone = styled.div<{ isDragActive: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: ${({ theme, isDragActive }) =>
    isDragActive
      ? theme.colors.primaryTint[100]
      : theme.colors.foreground.secondary[1]};
  border-radius: 20px; /* stylelint-disable-line scales/radii */
  cursor: pointer;

  :focus {
    border-color: ${({ theme }) => theme.colors.primaryTint[100]};
    -web-focus-ring: none;
    outline: none;
  }
`

export const DropzoneInstructions = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.foreground.secondary[4]};
  z-index: 1;
  user-select: none;
  cursor: pointer;
`

export const Label = styled.p`
  margin-top: 20px;
  margin-bottom: 6px; /* stylelint-disable-line scales/space */
  font-size: ${({ theme }) => theme.fontSizes.small};
`
